import $ from 'jquery';

export default class Article
{
  /**
   * Article インスタンスを生成します。
   *
   * @constructor
   * @param {number} id 記事 ID
   * @throws {TypeError} 変数 id が数値列ではない
   */
  constructor(id) {
    if (!$.isNumeric(id)) {
      throw new TypeError();
    }

    id = +id;

    /**
     * 記事 ID を取得します。
     *
     * @return {number}
     */
    this.getId = () => id;
  }

  /**
   * 記事を削除します。
   *
   * ログインユーザで記事の削除を試みます。
   *
   * @return {jQuery.Promise}
   */
  delete() {
    return $.ajax({
      url: `/${this.getId()}`,
      type: 'DELETE'
    });
  }

  /**
   * 記事を複製します。
   *
   * @return {jQuery.Promise}
   */
  duplicate() {
    return $.ajax({
      url: `/duplicate/${this.getId()}`,
      type: 'POST'
    });
  }

  /**
   * お気に入りへ登録します。
   *
   * ログインユーザで記事のお気に入り登録を試みます。
   *
   * @return {jQuery.Promise}
   */
  addFavorite() {
    return $.ajax({
      url: `/${this.getId()}/favorites`,
      type: 'POST'
    });
  }

  /**
   * お気に入りを解除します。
   *
   * ログインユーザで記事のお気に入り解除を試みます。
   *
   * @return {jQuery.Promise}
   */
  removeFavorite() {
    return $.ajax({
      url: `/${this.getId()}/favorites`,
      type: 'DELETE'
    });
  }
}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/scripts/models/Article.babel.js
 **/